import { closeTimesheetsDrawer } from '../State/timesheetsDrawer'

export default () => (dispatch) => {

  dispatch(closeTimesheetsDrawer())

}
